import { useSearchParams } from 'libs/router'
import { routes } from 'config/routes'

export const useProductPath = () => {
	const [searchParams] = useSearchParams()
	const query = searchParams.toString()

	return (id: number) =>
		query ? `${routes.productEdit(String(id))}?${query}` : routes.productEdit(String(id))
}
